import React, { useState, useEffect } from 'react'
import { useMutation } from 'react-query';
import axios from '../Api';
const usePutService = (data, api, buttonState) => {
    const [response6, setresponse] = useState("");
    const { isLoading: isPuting, mutate: putItem } = useMutation(
        async (data) => {
            return await axios.put(`${api}`,
                data
            );
        },
        {
            onSuccess: (res) => {
                const result = {
                    status: res.status + "-" + res.statusText,
                    headers: res.headers,
                    data: res.data,
                };
                setresponse(result)
                // setPostResult(fortmatResponse(result));
            },
            onError: (err) => {
                setresponse(err.response)
                // setPostResult(fortmatResponse(err.response?.data || err));
            },
        }
    );
    useEffect(() => {
        if (buttonState !== false) {
            putItem(data);
        }
    }, [buttonState]);
    return response6
}

export default usePutService